/** 命名空间 */
export const namespace = "ldt"
